import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Dictionary from "./Dictionary.js";

function App() {
  return (
    <div className="App container">
      <Dictionary />
    </div>
  );
}

export default App;
